import slide1 from './tara/slide1.png'
import slide2 from './tara/slide2.png'
import slide3 from './tara/slide3.png'
import slide4 from './tara/slide4.png'
import slide5 from './tara/slide5.png'
import slide6 from './tara/slide6.png'

export const TARA_SLIDES = [slide1, slide2, slide3, slide4, slide5, slide6]